import { useState, useEffect } from 'react';

import { getAirports } from './api';

const useApi = () => {
  const [airports, setAirports] = useState([]);
  const [status, setStatus] = useState('initial');

  useEffect(() => {
    if (status === 'initial') {
      getAirports()
        .then(({ data = {} }) => {
          setAirports(data);
          setStatus('ready');
        });
    }
  }, [status]);

  return {
    status,
    data: { airports }
  };
};

export default useApi;
